import Client from "./client";

const baseUrl = `/api/1/users`;

function user() {
  return {
    login: ({ params, payload }) => {
      const url = baseUrl + "/authenticate";
      return Client.postWithoutLoading(url, payload, {});
    },
    logout: ({ params, payload }) => {
      const url = baseUrl + "/logout";
      return Client.post(url, payload, {});
    },
    activate: ({ params, payload }) => {
      const url = baseUrl + "/activate/token";
      return Client.postWithoutLoading(url, payload, {});
    },

    register: ({ params, payload }) => {
      const url = baseUrl + "/register";
      return Client.postWithoutLoading(url, payload, {});
    },

    forgotPassword: ({ params, payload }) => {
      const url = baseUrl + "/forgot/password";
      return Client.postWithoutLoading(url, payload, {});
    },

    check: ({ params, payload }) => {
      const url = baseUrl + "/forgot/check";
      return Client.postWithoutLoading(url, payload, {});
    },

    ResetPassword: ({ params, payload }) => {
      const url = baseUrl + "/forgot/change";
      return Client.postWithoutLoading(url, payload, {});
    },
    ChangePassword: ({ params, payload }) => {
      const url = baseUrl + "/change";
      return Client.postWithoutLoading(url, payload, {});
    },
    ChangePasswordCode: ({ params, payload }) => {
      const url = baseUrl + "/change/check";
      return Client.postWithoutLoading(url, payload, {});
    },
    // changeMobile: ({ params, payload }) => {
    //   const url = baseUrl + "/change";
    //   return Client.post(url, payload, {});
    // },
    // validateChangeMobileCode: ({ params, payload }) => {
    //   const url = baseUrl + "/change/check";
    //   return Client.post(url, payload, {});
    // },
  };
}

export default user();
